import React from 'react'

import styles from './LoginButton.module.css'
// import Icon from '~/shared/atoms/Icon'

interface ButtonProps {
  icon?: string
  label?: string
}

const LoginButton: React.FC<ButtonProps & React.ButtonHTMLAttributes<HTMLButtonElement>> = ({ label, icon, ...props }) => {
  return (
    <button className={styles.loginButton} type='button' {...props}>
      {/* icon && <Icon className={styles.icon} icon={icon} /> */}
      {label}
    </button>
  )
}

export default LoginButton
